var _circle, _mask, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProgressS(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5.1,
    transform: "matrix(1 0 0 -1 0.571411 12)",
    stroke: "#3C3C3F",
    strokeWidth: 1.8
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_2213_6201",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5714 6C12.5714 5.21207 12.4162 4.43185 12.1147 3.7039C11.8132 2.97595 11.3712 2.31451 10.8141 1.75736C10.2569 1.20021 9.59546 0.758251 8.86751 0.456722C8.13956 0.155194 7.35934 0 6.57141 0L6.57141 1.73167C7.13194 1.73167 7.68697 1.84207 8.20483 2.05657C8.72269 2.27108 9.19323 2.58548 9.58958 2.98183C9.98593 3.37818 10.3003 3.84872 10.5148 4.36658C10.7293 4.88444 10.8397 5.43947 10.8397 6H12.5714Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5714 6C12.5714 5.21207 12.4162 4.43185 12.1147 3.7039C11.8132 2.97595 11.3712 2.31451 10.8141 1.75736C10.2569 1.20021 9.59546 0.758251 8.86751 0.456722C8.13956 0.155194 7.35934 0 6.57141 0L6.57141 1.73167C7.13194 1.73167 7.68697 1.84207 8.20483 2.05657C8.72269 2.27108 9.19323 2.58548 9.58958 2.98183C9.98593 3.37818 10.3003 3.84872 10.5148 4.36658C10.7293 4.88444 10.8397 5.43947 10.8397 6H12.5714Z",
    stroke: "#F7F5FF",
    strokeWidth: 4,
    strokeLinejoin: "round",
    mask: "url(#path-2-inside-1_2213_6201)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressS);
export default __webpack_public_path__ + "static/media/progress-s.9e13df0b606142bd9891e8e7be3306dc.svg";
export { ForwardRef as ReactComponent };